import { useJSONFetcher, JSONFetcherOptions } from "@outplayed/json-fetcher";
import { getApiRoot } from "@ugg/shared/api/api-helpers";
import { useUGGApiVersions } from "@ugg/shared/api/requests/ugg-api-versions";
import { useQueryString } from "@ugg/shared/hooks/use-query-string";
import { useValidateQueryParams } from "@ugg/shared/query-params/params-helpers";
import { validParams } from "@ugg/shared/query-params/valid-params";
import { TIER_LIST_PAGES } from "@ugg/shared/pages/tier-list-pages";

// Data Parsers
import { parseDuoTierList } from "@ugg/shared/api/data-parser/tier-lists/duo-tier-list";

// Interfaces
import { DuoTierList } from "@ugg/shared/interfaces/tier-lists/duo-tier-list.interface";

// ------------------------------------------------------------------------------------------------------------

interface TierListParams {
  region: string;
  patch: string;
  queueType: string;
  rank: string;
}

// ------------------------------------------------------------------------------------------------------------
// DUO TIER LIST
// ------------------------------------------------------------------------------------------------------------

function useDuoTierListURL(params: TierListParams) {
  const { data: version } = useUGGApiVersions({
    apiKey: "duos",
    patch: params.patch,
  });
  const root = getApiRoot(params.patch);

  return [`${root}/duos`, params.region, params.patch, params.queueType, params.rank, `${version}.json`].join("/");
}

export function useDuoTierList(
  options?: { params?: Record<string, any> } & JSONFetcherOptions<DuoTierList, ReturnType<typeof parseDuoTierList>>,
) {
  const { params = {}, ssr = false, skip = false } = options || {};
  const validateQueryParams = useValidateQueryParams(validParams);
  const validatedQueryParams = validateQueryParams(TIER_LIST_PAGES.DUO_TIER_LIST, params, true);

  const url = useDuoTierListURL(validatedQueryParams);
  return useJSONFetcher<DuoTierList, ReturnType<typeof parseDuoTierList>>(url, {
    skip,
    ssr,
    onCompleted: (url, json) => parseDuoTierList(json),
  });
}
